const ST1_odds = [
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option1",
    product: "A",
  },
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option1",
    answer3: "option1",
    answer4: "option3",
    product: "C",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option1",
    product: "A",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option1",
    answer3: "option2",
    answer4: "option3",
    product: "C",
  },
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option3",
    product: "C",
  },
  
  {
    answer2: "option1",
    answer3: "option3",
    answer4: "option4",
    product: "D",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option1",
    product: "A",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option2",
    answer3: "option1",
    answer4: "option3",
    product: "C",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option3",
    product: "C",
  },
  {
    answer2: "option2",
    answer3: "option2",
    answer4: "option4",
    product: "D",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option2",
    product: "B",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option3",
    product: "C",
  },
  {
    answer2: "option2",
    answer3: "option3",
    answer4: "option4",
    product: "D",
  },
  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option2",
    product: "B",
  },

  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option3",
    product: "C",
  },

  {
    answer2: "option3",
    answer3: "option1",
    answer4: "option4",
    product: "D",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option2",
    product: "B",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option3",
    product: "C",
  },

  {
    answer2: "option3",
    answer3: "option2",
    answer4: "option4",
    product: "D",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option2",
    product: "B",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option3",
    product: "C",
  },

  {
    answer2: "option3",
    answer3: "option3",
    answer4: "option4",
    product: "D",
  }
];

export default ST1_odds;
